export var generateGuid = function generateGuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
        v = c === 'x' ? r : r & 0x3 | 0x8; // eslint-disable-line

    return v.toString(16);
  });
};
var phaseNameExtractor = /\[fedops\] phase:([^ ]+) ([^ ]+) ?(.*) (started|finished)/;
export var getPhaseMark = function getPhaseMark(markName) {
  var matchs = phaseNameExtractor.exec(markName);

  if (matchs) {
    return {
      phaseName: matchs[1],
      appId: matchs[2],
      widgetId: matchs[3]
    };
  }
};